var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("系統紀錄中心")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("API Logs")])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('h4', {
    staticClass: "col-12 mb-4 font-weight-bold"
  }, [_vm._v(" " + _vm._s("\u3010".concat(_vm.organization.name, "\u3011API Logs")) + " ")])]), _c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.apiLogs,
      "fields": _vm.fields,
      "busy": _vm.isLoading
    },
    scopedSlots: _vm._u([{
      key: "table-busy",
      fn: function fn() {
        return [_c('div', {
          staticClass: "text-center my-2"
        }, [_c('b-spinner', {
          staticClass: "align-middle"
        })], 1)];
      },
      proxy: true
    }, {
      key: "cell(data)",
      fn: function fn(row) {
        return [row.item.data && row.item.data.length > 20 ? _c('b-button', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal.modal-data-view",
            modifiers: {
              "modal-data-view": true
            }
          }],
          staticClass: "flex-shrink-0 mr-2",
          attrs: {
            "variant": ""
          },
          on: {
            "click": function click($event) {
              _vm.dataForFullView = row.item.data;
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-arrow-expand-all"
        })]) : _vm._e(), _c('span', [_vm._v(_vm._s(_vm._f("hiddenString")(row.item.data, 20)))])];
      }
    }, {
      key: "cell(created_at)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(_vm.formatDate(data.item.created_at)) + " ")];
      }
    }, {
      key: "cell(updated_at)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(_vm.formatDate(data.item.updated_at)) + " ")];
      }
    }])
  }), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.total,
      "perPage": _vm.query.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  })], 1), _c('b-modal', {
    attrs: {
      "id": "modal-data-view",
      "title": "檢視完整 Data 內容"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var cancel = _ref.cancel;
        return [_c('b-button', {
          staticClass: "float-right",
          attrs: {
            "variant": "outline-danger",
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" 關閉 ")])];
      }
    }])
  }, [_c('JsonEditor', {
    attrs: {
      "height": "400px"
    },
    model: {
      value: _vm.dataForFullView,
      callback: function callback($$v) {
        _vm.dataForFullView = $$v;
      },
      expression: "dataForFullView"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }